// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 24px;
  font-family: sans-serif;
}

textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  resize: vertical;
  box-sizing: border-box;
}

.actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

button {
  padding: 10px 20px;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

button.secondary {
  background: #f1f5f9;
  color: #334155;
  border: 1px solid #e2e8f0;
}

.error-banner {
  background: #fee2e2;
  color: #991b1b;
  padding: 12px;
  border-radius: 6px;
  margin-top: 12px;
}

.report-output {
  margin-top: 24px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.report-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  font-size: 13px;
}

.label {
  font-weight: 600;
  color: #1e293b;
}

.streaming-badge {
  background: #dbeafe;
  color: #1d4ed8;
  padding: 2px 8px;
  border-radius: 99px;
}

.timestamp {
  margin-left: auto;
  color: #94a3b8;
}

.markdown-body {
  padding: 24px;
}

.debug-panel {
  margin-top: 16px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
}

.debug-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
}

.debug-badge {
  margin-left: auto;
  font-size: 12px;
  color: #7c3aed;
  background: #ede9fe;
  padding: 2px 8px;
  border-radius: 99px;
}

.debug-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
  padding: 16px;
}

.debug-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.debug-label {
  font-size: 12px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.debug-item strong {
  color: #0f172a;
  font-size: 16px;
  line-height: 1.2;
}`, "",{"version":3,"sources":["webpack://./src/app/_components/agent/agent-report/agent-report.component.scss"],"names":[],"mappings":"AAAA;EAAoB,gBAAA;EAAkB,cAAA;EAAgB,aAAA;EAAe,uBAAA;AAKrE;;AAJA;EAAW,WAAA;EAAa,aAAA;EAAe,sBAAA;EAAwB,kBAAA;EAC7D,eAAA;EAAiB,gBAAA;EAAkB,sBAAA;AAarC;;AAZA;EAAW,aAAA;EAAe,QAAA;EAAU,eAAA;AAkBpC;;AAjBA;EAAS,kBAAA;EAAoB,mBAAA;EAAqB,YAAA;EAAc,YAAA;EAC9D,kBAAA;EAAoB,eAAA;EAAiB,eAAA;AA0BvC;;AAzBA;EAAkB,YAAA;EAAc,mBAAA;AA8BhC;;AA7BA;EAAmB,mBAAA;EAAqB,cAAA;EAAgB,yBAAA;AAmCxD;;AAlCA;EAAgB,mBAAA;EAAqB,cAAA;EAAgB,aAAA;EAAe,kBAAA;EAAoB,gBAAA;AA0CxF;;AAzCA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,kBAAA;EAAoB,gBAAA;AAgDlF;;AA/CA;EAAiB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,kBAAA;EAC9D,mBAAA;EAAqB,gCAAA;EAAkC,eAAA;AAwDzD;;AAvDA;EAAS,gBAAA;EAAkB,cAAA;AA4D3B;;AA3DA;EAAmB,mBAAA;EAAqB,cAAA;EAAgB,gBAAA;EAAkB,mBAAA;AAkE1E;;AAjEA;EAAa,iBAAA;EAAmB,cAAA;AAsEhC;;AArEA;EAAiB,aAAA;AAyEjB;;AAxEA;EAAe,gBAAA;EAAkB,0BAAA;EAA4B,kBAAA;EAAoB,mBAAA;AA+EjF;;AA9EA;EAAgB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,kBAAA;EAAoB,gCAAA;AAsFnF;;AArFA;EAAe,iBAAA;EAAmB,eAAA;EAAiB,cAAA;EAAgB,mBAAA;EAAqB,gBAAA;EAAkB,mBAAA;AA8F1G;;AA7FA;EAAc,aAAA;EAAe,2DAAA;EAA6D,SAAA;EAAW,aAAA;AAoGrG;;AAnGA;EAAc,aAAA;EAAe,sBAAA;EAAwB,QAAA;EAAU,aAAA;EAAe,iBAAA;EAAmB,yBAAA;EAA2B,kBAAA;AA6G5H;;AA5GA;EAAe,eAAA;EAAiB,cAAA;EAAgB,yBAAA;EAA2B,sBAAA;AAmH3E;;AAlHA;EAAqB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AAwHtD","sourcesContent":[".report-container { max-width: 900px; margin: 0 auto; padding: 24px; font-family: sans-serif; }\ntextarea { width: 100%; padding: 12px; border: 1px solid #ddd; border-radius: 8px;\n  font-size: 14px; resize: vertical; box-sizing: border-box; }\n.actions { display: flex; gap: 8px; margin-top: 8px; }\nbutton { padding: 10px 20px; background: #2563eb; color: white; border: none;\n  border-radius: 6px; cursor: pointer; font-size: 14px; }\nbutton:disabled { opacity: 0.5; cursor: not-allowed; }\nbutton.secondary { background: #f1f5f9; color: #334155; border: 1px solid #e2e8f0; }\n.error-banner { background: #fee2e2; color: #991b1b; padding: 12px; border-radius: 6px; margin-top: 12px; }\n.report-output { margin-top: 24px; border: 1px solid #e2e8f0; border-radius: 8px; overflow: hidden; }\n.report-header { display: flex; align-items: center; gap: 12px; padding: 12px 16px;\n  background: #f8fafc; border-bottom: 1px solid #e2e8f0; font-size: 13px; }\n.label { font-weight: 600; color: #1e293b; }\n.streaming-badge { background: #dbeafe; color: #1d4ed8; padding: 2px 8px; border-radius: 99px; }\n.timestamp { margin-left: auto; color: #94a3b8; }\n.markdown-body { padding: 24px; }\n.debug-panel { margin-top: 16px; border: 1px dashed #cbd5e1; border-radius: 8px; background: #f8fafc; }\n.debug-header { display: flex; align-items: center; gap: 12px; padding: 12px 16px; border-bottom: 1px solid #e2e8f0; }\n.debug-badge { margin-left: auto; font-size: 12px; color: #7c3aed; background: #ede9fe; padding: 2px 8px; border-radius: 99px; }\n.debug-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); gap: 12px; padding: 16px; }\n.debug-item { display: flex; flex-direction: column; gap: 4px; padding: 12px; background: white; border: 1px solid #e2e8f0; border-radius: 8px; }\n.debug-label { font-size: 12px; color: #64748b; text-transform: uppercase; letter-spacing: 0.04em; }\n.debug-item strong { color: #0f172a; font-size: 16px; line-height: 1.2; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
